//Imports de components presents dans la page about
import React from "react";
import Topnav from "../components/Topnav.js";
import ContactComponent from "../components/ContactComponent.js";
import Footer from "../components/Footer.js";

//Création du composant
const Contact = () => {
    //Backend
    //Frontend
    return(
        <div>

            <Topnav />
            <ContactComponent />
            <Footer />
        </div>
    )
}

//Export du composant
export default Contact;
